<template>
	<div v-if="channel && channel.isLoaded">
		<Register ref="register" v-if="isSoccer" />
		<Contact ref="contact" v-else />
		<Loader />
	</div>
</template>

<script>
	import Register from "./components/register.vue";
	import Contact from "./components/contact.vue";
	import Loader from "./components/ui/loader.vue";
	import appStart from "@/mixins/appStart";
	import {
		mapActions
	} from 'vuex';

	export default {
		mixins: [appStart],
		name: "d21-app-content",
		components: {
			Loader,
			Register,
			Contact,
		},
		computed: {
			isSoccer() {
				return window.location.href.toLowerCase().indexOf("fc-schaffhausen") !== -1;
			}
		},
		methods: {
			...mapActions(["initRegistration"])
		},
		created() {
			if (!this.registration) {
				this.initRegistration();
			}
		}
	};
</script>